const storage = {
    //getters
    getString: (key) => {
        return localStorage.getItem(key)
    },
    getObject: (key) => {
        let found = localStorage.getItem(key);
        if (found) {
            try {
                return JSON.parse(found);
            } catch (ex) {
                return null;
            }
        } else {
            return null;
        }
    },

    getCollectionObject: (collection, key) => {
        return new Promise((resolve, reject) => {
            if (key) { //get single item
                let found = localStorage.getItem(collection + "#" + key);
                if (found) {
                    try {
                        let obj = JSON.parse(found);
                        resolve(obj);
                    } catch (ex) {
                        reject(ex);
                    }
                } else {
                    reject();
                }
            } else { //get all from collection
                let result = [];
                for (var i = 0; i < localStorage.length; i++) {
                    if (localStorage.key(i).indexOf(collection + '#') >= 0) {
                        let found = storage.getObject(localStorage.key(i))
                        if (found) result.push(found);
                    }
                }
                resolve(result);
            }
        })
    },

    deleteCollectionObject: (collection, key) => {
        if (key) {
            localStorage.removeItem(collection + "#" + key);
        } else {
            for (var i = 0; i < localStorage.length; i++) {
                if (localStorage.key(i).indexOf(collection + '#') >= 0) {
                    localStorage.removeItem(localStorage.key(i));
                }
            }
        }
    },

    //setters
    setString: (key, value) => {
        localStorage.setItem(key, value);
    },
    setObject: (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
    },
    setCollectionObject: (collection, key, value) => {
        localStorage.setItem(collection + "#" + (key ? key : ''), JSON.stringify(value));
    },
    delete: (key) => {
        localStorage.removeItem(key);
    },
    clear: () => {
        localStorage.clear();
    },
    getAllKeys: (filter) => {
        let result = [];
        for (var i = 0; i < localStorage.length; i++) {
            if (filter) {
                if (localStorage.key(i).indexOf(filter) >= 0) {
                    result.push(localStorage.key(i));
                }
            } else {
                result.push(localStorage.key(i));
            }

        }
        return result;
    }
}
export default storage;